import React from 'react'
import { chooseWallpaper, translate } from "../../utils/useful";
import Responsive from '../../components/Responsive';
import CustomLoader from '../../components/CustomLoader';
import StagesManager from '../../components/StagesManager';


class RoomsHistory extends React.Component {
    state = {
        videocalls: [
            { icon: "/assets/icons/rooms/rejected.svg", color: "#FF3B30", name: "Class 101", creator: "Pouya Pezhman", date: "Today, 9:55 AM" },
            { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "React Native class 234", creator: "Pouya Pezhman", date: "Yesterday, 5:25 PM" },
            { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "Math Elemntry 209", creator: "Pouya Pezhman", date: "3/5/23, 10:55 AM" },
        ],
        isLoader: false
    }

    componentDidMount() {

    }

    componentWillUnmount() {
    }


    changePage = (item) => {

        this.setState({ currentPage: item.key })
    }




    render() {
        return (

            <div className='flexcc' style={{}}>
                <div className=' w-100 scroll-no-scrollbar'>
                    <div className='mt-3'>
                        {this.state.videocalls.map((prop, index) => {
                            return (
                                <div className='bb-gray hover-gray2 mx-3 px-2 br-5'>
                                    <button className='flexcb w-100 py-2'>
                                        <div className='flexc'>
                                            <img className='mrd-2' src={prop.icon} />
                                            <div className='text-start'>
                                                <p className='weight-500 font-size-14' style={{ color: prop.color }}>{prop.name}</p>
                                                <p className='weight-300 font-size-10' style={{ color: prop.color }}>{prop.creator}</p>
                                            </div>
                                        </div>
                                        <div className='prd-2 font-size-10' style={{ color: prop.color }}>{prop.date}</div>
                                    </button>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>

        )
    }
}

export default RoomsHistory;